import { render, staticRenderFns } from "./SharedCPDDashboardWidget.vue?vue&type=template&id=79a86758&scoped=true"
import script from "./SharedCPDDashboardWidget.vue?vue&type=script&lang=js"
export * from "./SharedCPDDashboardWidget.vue?vue&type=script&lang=js"
import style0 from "./SharedCPDDashboardWidget.vue?vue&type=style&index=0&id=79a86758&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a86758",
  null
  
)

export default component.exports